module.exports = __webpack_public_path__ + "img/seminar-1993.9ad627eb.jpg";